<template>
  <div>
    <b-modal
      v-show="!modalLoad"
      id="modal-task-list"
      ref="tasklistform"
      cancel-variant="outline-secondary"
      :ok-title="bTitle"
      cancel-title="Close"
      :title="$t('ADD_TASK_LIST')"
      size="lg"
      no-close-on-backdrop
      @ok="handleSubmit"
      @hidden="resetModal"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoad === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <validation-observer ref="taskListFormValidation">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                md="12"
              >

                <b-form-group
                  :label="$t('DEBTIA_ACCCESS_TO')"
                  label-for="roles"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Access To"
                    rules="required"
                  >
                    <v-select
                      v-model="selectedTaskAccessTo"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="taskAccessTo"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="roles"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedTaskAccessTo === 'user'"
                cols="12"
                md="12"
              >

                <b-form-group
                  :label="$t('DEBTIA_USERS')"
                  label-for="roles"
                >
                  <validation-provider
                    #default="{ errors }"
                    name=" "
                    rules="required"
                  >
                    <v-select
                      v-model="selectedUsers"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="userslist"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="roles"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="selectedTaskAccessTo === 'role'"
                cols="12"
                md="12"
              >

                <b-form-group
                  :label="$t('DEBTIA_ROLES')"
                  label-for="roles"
                >
                  <validation-provider
                    #default="{ errors }"
                    name=" "
                    rules="required"
                  >
                    <v-select
                      v-model="role"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="roles"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="roles"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >

                <b-form-group
                  :label="$t('DEBTIA_TYPE')"
                  label-for="roles"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Type"
                    rules="required"
                  >
                    <v-select
                      v-model="tasktype"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="tasktypelist"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="roles"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  :label="$t('DEBTIA_TITLE')"
                  label-for="item-name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Title"
                    rules="required"
                  >
                    <b-form-input
                      id="item-name"
                      v-model="title"
                      type="text"
                      :placeholder="$t('DEBTIA_TITLE')"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="item-name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Description"
                    rules="required"
                  >
                    <b-form-textarea
                      id="textarea-rows"
                      v-model="description"
                      :placeholder="$t('DEBTIA_DESCRIPTION')"
                      rows="4"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <div
              v-if="!tasktype"
              class="demo-spacing-0"
            >
              <label>
                <h4>Tasks</h4>
              </label>
              <b-alert
                variant="warning"
                show
              >
                <div class="alert-body">
                  Select the task type first.
                </div>
              </b-alert>
            </div>
            <div
              v-else
            >
              <b-row
                v-for="(item, index) in items"
                :id="item.id"
                :key="item.id"
                ref="row"
              >

                <b-col
                  cols="12"
                  md="12"
                >
                  <h5>Task {{ index+1 }}</h5>
                  <b-alert
                    :id="'alert-'+index"
                    class="taskListItemAlert"
                    variant="warning"
                    show
                  >
                    <div class="alert-body">
                      {{ $t('DEBTIA_TASKLIST_ITEM_EXISTS') }}
                    </div>
                  </b-alert>
                  <b-form-group
                    :label="getTypeLabel()"
                    label-for="cases"
                  >
                    <v-select
                      v-model="item.task_list.refID"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="getTypeOptions()"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="cases"
                      @input="elementCheck(item.task_list.refID, index)"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  md="12"
                  class="mb-50"
                >
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="mt-0 mt-md-2 float-right"
                    @click="removeItem(index)"
                  >
                    <feather-icon
                      icon="XIcon"
                      class="mr-25"
                    />
                    <span>Delete</span>
                  </b-button>
                </b-col>

                <b-col cols="12">
                  <hr>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </validation-observer>
        <b-button
          v-if="tasktype"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="repeateAgain"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-25"
          />
          <span>Add New</span>
        </b-button>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BOverlay, BFormGroup, BForm, BFormInput,
  BButton, BCol, BRow, BFormTextarea, BAlert,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import i18n from '@/libs/i18n'
import { heightTransition } from '@core/mixins/ui/transition'

export default {
  components: {
    BModal,
    BOverlay,
    BFormGroup,
    BForm,
    BFormInput,
    BButton,
    vSelect,
    BCol,
    BRow,
    BFormTextarea,
    BAlert,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    modalLoads: {
      type: Boolean,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    cases: {
      type: Array,
      required: true,
    },
    debtors: {
      type: Array,
      required: true,
    },
    clients: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      modalLoader: true,
      loader: true,
      bTitle: 'Save',
      title: '',
      description: '',
      selectedTaskAccessTo: '',
      userslist: [],
      items: [
        {
          id: 1,
          task_list:
            {
              refID: 0,
              showValidationMsg: false,
              vMsg: '',
            },
        },
      ],
      tasktype: '',
      tasktypelist: [
        { label: 'Case', value: 'case' },
        { label: 'Debtor', value: 'debtor' },
        { label: 'Client', value: 'client' },
      ],
      taskAccessTo: [
        { label: 'User', value: 'user' },
        { label: 'Role', value: 'role' },
      ],
      nextTodoId: 2,
      roles: [{
        label: 'Select Role',
        value: null,
      }],
      role: null,
      modalLoad: false,
      selectedUsers: '',
    }
  },
  watch: {
    selectedTaskAccessTo: {
      handler() {
        this.fetchUsers()
      },
    },
  },
  created() {
    this.getRoles()
  },
  methods: {
    selectedTaskItemsExists(value) {
      let exists = 0
      if (this.items.length > 0) {
        exists = this.items.filter(element => element.task_list.refID === value)
      }
      return exists.length > 1
    },
    elementCheck(value, index) {
      if (this.selectedTaskItemsExists(value)) {
        this.items[index].task_list.refID = 0
        document.getElementById(`alert-${index}`).style.display = 'block'
        this.hideItemAlert(index)
      }
    },
    hideItemAlert(index) {
      setTimeout(() => {
        document.getElementById(`alert-${index}`).style.display = 'none'
      }, 5000)
    },
    getTypeOptions() {
      let arr = []
      if (this.tasktype === 'case') {
        arr = this.cases
      } else if (this.tasktype === 'debtor') {
        arr = this.debtors
      } else {
        arr = this.clients
      }
      return arr
    },
    getTypeLabel() {
      let label = ''
      if (this.tasktype === 'case') {
        label = i18n.t('DEBTIA_CASES')
      } else if (this.tasktype === 'debtor') {
        label = i18n.t('DEBTIA_DEBTORS')
      } else {
        label = i18n.t('DEBTIA_CLIENTS')
      }
      return label
    },
    async fetchUsers() {
      this.modalLoad = true
      this.userslist = []
      await axios.get('/users/get-users?perPage=100000')
        .then(response => {
          // console.log('response ', response.data.data.data)
          this.modalLoad = false
          const usersarray = response.data.data.data
          usersarray.forEach(value => {
            const obj = {
              label: value.name,
              value: value.id,
            }
            this.userslist.push(obj)
          })
          // console.log('userslist ', this.userslist)
        })
    },
    async handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.taskListFormValidation.validate().then(success => {
        if (success) {
          this.modalLoad = true
          const data = []
          const taskList = []
          this.items.forEach(element => {
            // if (element.task_list.refID === 0) {
            // this.items[i].task_list.showValidationMsg = true
            // this.items[i].task_list.vMsg = 'Field is required'
            // return
            // }
            if (element.task_list.refID !== 0) {
              taskList.push(element.task_list)
            }
          })
          data.task_list = taskList
          data.role = this.role
          const selectedAccessID = this.selectedTaskAccessTo === 'user' ? this.selectedUsers : this.role
          const listItems = []
          data.task_list.forEach(element => {
            listItems.push({ ref: element.refID })
          })
          const obj = {
            title: this.title,
            description: this.description,
            type: this.tasktype,
            accessTo: {
              type: this.selectedTaskAccessTo,
              ref: selectedAccessID,
            },
            listItems,
          }
          axios.post('task-list/add-role-list', { ...obj })
            .then(response => {
              this.showValidationMsg = false
              this.vMsg = ''
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Task List',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: response.data.message,
                },
              })
              this.$refs.tasklistform.hide()
              this.modalLoad = false
              this.resetModal()
              this.reloadMethod()
            })
        }
      })
    },
    resetModal() {
      this.selectedTaskAccessTo = ''
      this.selectedUsers = ''
      this.role = ''
      this.tasktype = ''
      this.title = ''
      this.description = ''
      this.items = [
        {
          id: 1,
          task_list:
            {
              refID: 0,
              showValidationMsg: false,
              vMsg: '',
            },
        },
      ]
    },
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
        task_list: {
          refID: 0,
          showValidationMsg: false,
          vMsg: '',
        },
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
    },
    async getRoles() {
      try {
        this.loader = true
        const getRoles = await axios.get('/role-management/get-roles-id-dropdown')
        if (getRoles.status) {
          this.roles.push(...getRoles.data.data)
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
  },
}
</script>

<style>
.taskListItemAlert {
  display: none;
}
</style>
